import { Component, OnInit } from '@angular/core';
import {IDashboardProjOutputModel, IProjDocDashboardOutputModel, IJobMHInputModel, IJobMHOutputModel } from 'src/app/ViewModel/DashboardModel';
import { DashboardService } from 'src/app/Service/dashboard/dashboard.service';
import { CommonService } from 'src/app/Service/Common.service';
import { forkJoin, Observable } from 'rxjs';

@Component({
  selector: 'app-project-dashboard',
  templateUrl: './project-dashboard.component.html',
  styleUrls: ['./project-dashboard.component.css']
})

export class ProjectDashboardComponent implements OnInit {
  dashboardDetails!: IDashboardProjOutputModel;
  totalDays: number = 0;
  completedDays: number = 0;
  remainingDays: number = 0;
  overDueDays: number = 0;
  plannedDocuments: number = 0;
  completedDocuments: number = 0;
  balanceDocuments: number = 0;
  plannedManHours: number = 0;
  actualManHours: number = 0;
  balanceManHours: number = 0;
  projectId!: number ;
  memberId!: number ;
  projectCode!: string ;
  center:any="center"
  projectDetails: IProjDocDashboardOutputModel[] =[];
  projectScheduleDetails: IProjDocDashboardOutputModel[] = [];
  projectDocScheduleMHDetails: IProjDocDashboardOutputModel[] = [];
  projectDocScheduleMHDetails1: IProjDocDashboardOutputModel[] = [];
  scheduleCount: number = 0;
  scheduleMHCount: number = 0;
  public data: any[] = [];

  public dynamicHeight = true;
  constructor(private _dashboardService: DashboardService, private _commonService: CommonService) { }

  ngOnInit() {
    this.projectId = this._commonService.getProjectId();
    this.memberId = this._commonService.getLoggedInUserId();
    this.projectCode = this._commonService.getProjectCode();
    this.loadDashboardDocDetails();
    
   
  }

  loadJobManhourDetails(){
    let projInput: IJobMHInputModel = {
      project_Code : this.projectCode
    }

    this._dashboardService.GetJobWiseMHDetails(projInput).subscribe((res: IJobMHOutputModel[]) => {
        this.projectDocScheduleMHDetails1 = this.projectDocScheduleMHDetails;
        this.actualManHours = !!res[0].actual_Manhour ? res[0].actual_Manhour : 0;
        this.balanceManHours = this.plannedManHours - this.actualManHours;
        let index = this.projectDocScheduleMHDetails1.findIndex(x => x.status == "Completed ManHours");
        this.projectDocScheduleMHDetails1[index].doc_Count = res[0].actual_Manhour;
        this.projectDocScheduleMHDetails1[index].doc_Percentage = ((res[0].actual_Manhour * 100) / this.plannedManHours).toFixed(2);
        let index1 = this.projectDocScheduleMHDetails1.findIndex(x => x.status == "Remaining ManHours");
        this.projectDocScheduleMHDetails1[index1].doc_Count = this.balanceManHours;
        this.projectDocScheduleMHDetails1[index1].doc_Percentage = ((this.balanceManHours * 100) / this.plannedManHours).toFixed(2);
    });
    
  }


  loadDashboardDetails(res: IDashboardProjOutputModel) {
      this.dashboardDetails = res;
      this.totalDays = res.totalDays;
      this.completedDays = res.completedDays;
      this.remainingDays = Math.sign(res.remainingDays) == 1 ? res.remainingDays : 0;
      this.overDueDays = Math.sign(res.remainingDays) == -1 ? res.remainingDays : 0;
      this.plannedDocuments = res.plannedDocuments;
      this.completedDocuments = res.completedDocuments;
      this.balanceDocuments = res.balanceDocuments;
      this.plannedManHours = res.plannedManHours;
      this.actualManHours = res.actualManHours;
      this.balanceManHours = res.balanceManHours;
  }

  loadDashboardDocDetails() {
    let dashboardDetails: Observable<IDashboardProjOutputModel> = this._dashboardService.GetProjDashboardDetails({ project_Id: this.projectId });
    let projectDetails: Observable<IProjDocDashboardOutputModel[]> = this._dashboardService.GetProjDashboardDocDetails({ project_Id: this.projectId, trans_Type: 'Project' });
    let scheduleDocDetails: Observable<IProjDocDashboardOutputModel[]> = this._dashboardService.GetProjDashboardDocDetails({ project_Id: this.projectId, trans_Type: 'Schedule' });
    let scheduleMHDetails: Observable<IProjDocDashboardOutputModel[]> = this._dashboardService.GetProjDashboardDocDetails({ project_Id: this.projectId, trans_Type: 'ManHours' });


    forkJoin(dashboardDetails, projectDetails, scheduleDocDetails, scheduleMHDetails).subscribe((res: any[]) => {
      this.loadDashboardDetails(res[0]);
      this.projectDetails = res[1];
      this.projectScheduleDetails = res[2];
      this.projectDocScheduleMHDetails = res[3];
     
      this.scheduleCount = this.projectScheduleDetails.filter(x=> x.doc_Count > 0).length;
      this.scheduleMHCount = this.projectDocScheduleMHDetails.filter(x=> x.doc_Count > 0).length;
      this.loadJobManhourDetails();
     }
    );
     
    
  }


  public labelContent(e: any): string {
    return e.category;
  }

}